export const EVENT_IDS = {
  NPS_SURVEY_VIEWED: 'nps_survey_viewed',
  NPS_RATING_SUBMITTED: 'nps_rating_submitted',
  NPS_FEEDBACK_SUBMITTED: 'nps_feedback_submitted',
  NPS_SURVEY_COMPLETED: 'nps_survey_completed',
  NPS_SURVEY_SKIPPED: 'nps_survey_skipped',
  TUTOR_BLOCKED: 'tutor_blocked',
  TUTOR_BLOCK_FAILED: 'tutor_block_failed',
  TUTOR_UNBLOCKED: 'tutor_unblocked',
  TUTOR_UNBLOCK_FAILED: 'tutor_unblock_failed',
  TUTOR_EXCLUSION_ACTION_CLICKED: 'tutor_exclusion_action_clicked',
  TUTOR_CONNECT_PROFILE_VIEWED: 'tutor_connect_profile_viewed',
  TUTOR_CONNECT_PROFILE_SCHEDULE_OPENED: 'tutor_connect_profile_schedule_opened',
  TUTOR_CONNECT_SCHEDULE_DATE_CHANGED: 'tutor_connect_schedule_date_changed',
  TUTOR_CONNECT_FAVORITE_SLOT_DISPLAYED: 'tutor_connect_favorite_slot_displayed',
  TUTOR_CONNECT_FAVORITE_SLOT_CLICKED: 'tutor_connect_favorite_slot_clicked',
  TUTOR_CONNECT_BOOKING_ATTEMPTED: 'tutor_connect_booking_attempted',
  TUTOR_CONNECT_BOOKING_OUTCOME: 'tutor_connect_booking_outcome',
  TUTOR_CONNECT_PICKER_CARD_CLICKED: 'tutor_connect_picker_card_clicked',
  TUTOR_CONNECT_PICKER_FAVORITE_CLICKED: 'tutor_connect_picker_favorite_clicked',
  TUTOR_CONNECT_PRODUCT_PACK_SELECTED: 'tutor_connect_product_pack_selected',
  LESSON_START_STYLE_IMPRESSION: 'lesson_start_style_impression',
  LESSON_START_STYLE_SELECTED: 'lesson_start_style_selected',
  LESSON_START_STYLE_SAVED: 'lesson_start_style_saved',
} as const
